import {
  PreviewBusiness,
  PreviewEvent,
  PreviewFeedback,
  PreviewSocial,
  PreviewVideo,
  PreviewWifi,
  PreviewText,
  PreviewEmail,
  PreviewUrlStatic,
  PreviewSMS,
  PreviewWhatsapp,
} from "@/components/previews";

import { AppsTemplate } from "@/features/previews/templates/apps";
import { VcardTemplate } from "@/features/previews/templates/vcard";
import { PdfPreview } from "@/features/previews/templates/pdf";
import { UrlTemplate } from "@/features/previews/templates/url";
import { ImagesPreview } from "@/features/previews/templates/images";
import { EmptyPreview } from "@/features/previews/templates/empty";
import { YoutubeTemplate } from "@/features/previews/templates/youtube";
import { ListLinksTemplate } from "@/features/previews/templates/list-links";
import { WebsiteTemplate } from "@/features/previews/templates/website";
import { CouponTemplate } from "@/features/previews/templates/coupon";
import { Mp3Template } from "@/features/previews/templates/mp3";

import { previewRegistry } from "./PreviewRegistry";
import { QRProps } from "../types";

let initialized = false;

// Registers every legacy preview component under the same keys as `data.type`.
export const initializePreviewRegistry = (): void => {
  if (initialized) {
    return;
  }
  initialized = true;

  previewRegistry.registerLegacy("business", PreviewBusiness);
  previewRegistry.registerLegacy("video", PreviewVideo);
  previewRegistry.registerLegacy("wifi", PreviewWifi);
  previewRegistry.registerLegacy("social", PreviewSocial);
  previewRegistry.registerLegacy("event", PreviewEvent);
  previewRegistry.registerLegacy("feedback", PreviewFeedback);
  previewRegistry.registerLegacy("text", PreviewText);
  previewRegistry.registerLegacy("email", PreviewEmail);
  previewRegistry.registerLegacy("url-static", PreviewUrlStatic);
  previewRegistry.registerLegacy("sms", PreviewSMS);
  previewRegistry.registerLegacy("whatsapp", PreviewWhatsapp);

  previewRegistry.register(
    "empty" as any,
    EmptyPreview,
    () =>
      import("@/features/previews/templates/empty/initPreviewEmptyData.json") as unknown as Promise<
        QRProps<any>
      >
  );

  previewRegistry.register(
    "apps",
    AppsTemplate,
    () =>
      import("@/features/previews/templates/apps/initPreviewAppsData.json") as unknown as Promise<
        QRProps<"apps">
      >
  );

  previewRegistry.register(
    "vcard",
    VcardTemplate,
    () =>
      import("@/features/previews/templates/vcard/initPreviewVcardData.json") as unknown as Promise<
        QRProps<"vcard">
      >
  );

  previewRegistry.register(
    "pdf",
    PdfPreview,
    () =>
      import("@/features/previews/templates/pdf/initPreviewData.json") as unknown as Promise<
        QRProps<"pdf">
      >
  );

  previewRegistry.register(
    "url",
    UrlTemplate,
    () =>
      import("@/features/previews/templates/url/initPreviewUrlData.json") as unknown as Promise<
        QRProps<"url">
      >
  );

  previewRegistry.register(
    "image",
    ImagesPreview,
    () =>
      import("@/features/previews/templates/images/initPreviewImagesData.json") as unknown as Promise<
        QRProps<"image">
      >
  );

  previewRegistry.register(
    "listoflinks",
    ListLinksTemplate,
    () =>
      import("@/features/previews/templates/list-links/initPreviewListLinksData.json") as unknown as Promise<
        QRProps<"listoflinks">
      >
  );

  previewRegistry.register(
    "website",
    WebsiteTemplate,
    () =>
      import("@/features/previews/templates/website/initPreviewWebsiteData.json") as unknown as Promise<
        QRProps<"website">
      >
  );

  previewRegistry.register(
    "coupon",
    CouponTemplate,
    () =>
      import("@/features/previews/templates/coupon/initPreviewCouponData.json") as unknown as Promise<
        QRProps<"coupon">
      >
  );

  previewRegistry.register(
    "youtube",
    YoutubeTemplate,
    () =>
      import("@/features/previews/templates/youtube/initPreviewYoutubeData.json") as unknown as Promise<
        QRProps<"youtube">
      >
  );

  previewRegistry.register(
    "mp3",
    Mp3Template,
    () =>
      import("@/features/previews/templates/mp3/initPreviewMp3Data.json") as unknown as Promise<
        QRProps<"mp3">
      >
  );
};
